import { Platform } from 'react-native';

const buildMessage = (url: string) =>
  `Bonanza social! A real gaming online casino made for slot lovers and casual gamers. It's me time. ${url}`;

export const buildWhatsappUrl = (url: string) =>
  `whatsapp://send?text=${encodeURIComponent(buildMessage(url))}`;

export const buildSmsUrl = (url: string) => {
  const body = encodeURIComponent(buildMessage(url));
  const scheme = Platform.OS === 'android' ? 'smsto:' : 'sms:';
  const sep = Platform.OS === 'android' ? '?' : '&';
  return `${scheme}${sep}body=${body}`;
};

export const buildMailtoUrl = (url: string) => {
  const subject = encodeURIComponent('Play Bonanza with me! 🎰💛');
  const body = encodeURIComponent(buildMessage(url));
  return `mailto:?subject=${subject}&body=${body}`;
};
